import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';

import { ConfirmComponent } from '../../modals';
import { MeetingsService } from '../../services';
import { TasksService } from '../../services';


export interface CalendarModalModel {
	title:string;
    event:any;
}

@Component({  
    selector: 'calendar-modal',
    templateUrl: './calendar-modal.html',
    styleUrls: ['./calendar-modal.scss']
})

export class CalendarModalComponent extends DialogComponent<CalendarModalModel, any> implements CalendarModalModel, OnInit {
  	title:string;
    event:any;

    data = [];
    filterQuery = '';
    rowsOnPage = 10;
    sortBy = 'name';
    sortOrder = 'asc';

    private local = 'DD.MM.YYYY. HH:mm';
    
    private helper = {
        start: '',
        end: '',
        edit_delete: true
    };

    public status = [];

  	constructor(
        private router: Router,
        private meetingsService: MeetingsService,
        private tasksService: TasksService,
        private toastr: ToastrService,
        dialogService: DialogService
    ) {
    	super(dialogService);
  	}

    ngOnInit() {

        this.status = [
            'Nije odgovorio/la', 
            'Prihvaćen',
            'Odbijen'
        ];

        if(this.event.event === 'meeting'){
            let start = moment(this.event.start._i).format(this.local);
            this.helper.start = start;

            if(this.event.end){
                let end = moment(this.event.end._i).format(this.local);
                this.helper.end = end;
            } else {
                this.helper.end = '';
            }

            if (localStorage.getItem('roleName') === 'administrator') {
                this.helper.edit_delete = true;
            } else if(localStorage.getItem('userId') == this.event.author_id){
                this.helper.edit_delete = true;
            }

        } else {
            let start = moment(this.event._start._i).format(this.local);
            this.helper.start = start;

            if (localStorage.getItem('roleName') === 'administrator') {
                this.helper.edit_delete = true;
            } else if(localStorage.getItem('userId') == this.event.author_id){
                this.helper.edit_delete = true;
            }

            this.getSpecificTask();
        } 
    }

    // Meetings
    editMeeting(event){
        this.close();
        this.router.navigate([`/pages/meetings/${event.id}/edit`]);
        localStorage.setItem('calendar', 'true');
    }

    deleteMeeting(event){
        let activeModal = this.dialogService.addDialog(ConfirmComponent, {
            title:'Izbriši sastanak', 
            message:'Jeste li sigurni da želite izbrisati ' + event.title + ' ?',
            button: 'Izbriši',
        })
        .subscribe((isConfirmed)=>{
            if(isConfirmed) {
                this.meetingsService.deleteMeeting(event.id).subscribe(
                    response => {
                        this.toastr.success(response.message);
                        this.result = true;
                        this.close();
                    },
                    error => {
                        if(error.error_msg){
                            this.toastr.error(error.error_msg);
                        }
                    },
                );
            }
        });
    }

    getSpecificTask() {
		this.tasksService.getSpecificTask(this.event.id).subscribe(
			response => {
                console.log(response);
                this.data = response.task.performers;
			},
			error => {
				if(error.error_msg){
					this.toastr.error(error.error_msg);
				}
			},
		);
    }
    
    // Tasks
    editTask(event){
        this.close();
        this.router.navigate([`/pages/tasks/${event.id}/edit`]);
        localStorage.setItem('calendar', 'true');
    }

    deleteTask(event){
        let activeModal = this.dialogService.addDialog(ConfirmComponent, {
            title:'Izbriši zadatak', 
            message:'Jeste li sigurni da želite izbrisati ' + event.title + ' ?',
            button: 'Izbriši',
        })
        .subscribe((isConfirmed)=>{
            if(isConfirmed) {
                this.tasksService.deleteTask(event.id).subscribe(
                    response => {
                        this.toastr.success(response.message);
                        this.result = true;
                        this.close();
                    },
                    error => {
                        if(error.error_msg){
                            this.toastr.error(error.error_msg);
                        }
                    },
                );
            }
        });
    }
}






// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/modals/calendar/calendar-modal.component.ts